
import React from "react";

const DeleteConfirmationModal = ({ onConfirm, onCancel }) => {
    return (
        <div className="delete-confirmation-modal">
            <div className="modal-overlay">
                <div className="modal-content">
                    <h3>Are you sure you want to delete?</h3>
                    <div className="modal-buttons mx-auto">
                        <a className="btn btn-danger" onClick={onConfirm}>
                            Delete
                        </a>
                        <button className="btn btn-secondary" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
